module.exports = __webpack_public_path__ + "img/14.311f8b39.png";